/* eslint no-underscore-dangle: 0 */
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import Chip from 'ui-component/extended/Chip';

import Spinner from 'components/spinner';
import dayjs from 'dayjs';
import { ActionMenu } from '../actionMenu';

const headCells = [
    { id: 'title', label: 'Title', align: 'center' as const },
    { id: 'code', label: 'Code', align: 'center' as const },
    { id: 'setupDiscount', label: 'Setup Discount', align: 'center' as const },
    { id: 'subscriptionDiscount', label: 'Subscription Discount', align: 'center' as const },
    { id: 'uses', label: 'Uses', align: 'center' as const },
    { id: 'dateCreated', label: 'Date Created', align: 'center' as const },
    { id: 'status', label: 'Status', align: 'center' as const },
    { id: 'action', label: 'Action', align: 'center' as const }
];

const formatDiscount = (method: string | null, amount: number | null): string => {
    if (!method || amount == null) return '--';
    if (method === 'Percent') return `${amount}%`;
    return `$${amount}`;
};

const formatSubscriptionDiscount = (method: string | null, amount: number | null, duration: string | null): string => {
    if (!method || amount == null) return '--';
    const discountStr = method === 'Percent' ? `${amount}%` : `$${amount}`;
    if (!duration) return discountStr;
    if (duration === 'once') return `${discountStr} once`;
    if (duration === 'indefinite') return `${discountStr} indefinite`;
    return `${discountStr} for ${duration} month${parseInt(duration) > 1 ? 's' : ''}`;
};

type BrandedAppPromoCodeTableProps = {
    promoCodeList: any[];
    handleRefetch: () => void;
    loading: boolean;
};

const BrandedAppPromoCodeTable = ({ promoCodeList, handleRefetch, loading }: BrandedAppPromoCodeTableProps) => {
    if (loading) {
        return <Spinner />;
    }

    return (
        <TableContainer>
            <Table sx={{ minWidth: 750 }} aria-labelledby="tableTitle">
                <TableHead>
                    <TableRow>
                        {headCells.map((headCell) => (
                            <TableCell key={headCell.id} align={headCell.align}>
                                {headCell.label}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>

                <TableBody>
                    {!promoCodeList?.length ? (
                        <TableRow sx={{ borderBottom: 'none' }}>
                            <TableCell colSpan={headCells.length} align="center">
                                <h1>No Items</h1>
                            </TableCell>
                        </TableRow>
                    ) : (
                        <>
                            {promoCodeList.map((promoCode) => (
                                <TableRow key={promoCode._id}>
                                    <TableCell align="center">{promoCode.title}</TableCell>
                                    <TableCell align="center">{promoCode.code}</TableCell>
                                    <TableCell align="center">
                                        {formatDiscount(promoCode.setupDiscountMethod, promoCode.setupDiscountAmount)}
                                    </TableCell>
                                    <TableCell align="center">
                                        {formatSubscriptionDiscount(
                                            promoCode.subscriptionDiscountMethod,
                                            promoCode.subscriptionDiscountAmount,
                                            promoCode.subscriptionDiscountDuration
                                        )}
                                    </TableCell>
                                    <TableCell align="center">{promoCode.usageCount ?? 0}</TableCell>
                                    <TableCell align="center">{dayjs(promoCode.createdAt).format('D MMMM YYYY')}</TableCell>
                                    <TableCell align="center">
                                        {promoCode.status === 'active' && (
                                            <Chip
                                                label={promoCode.status?.charAt(0).toUpperCase() + promoCode.status?.slice(1)}
                                                size="medium"
                                                chipcolor="success"
                                            />
                                        )}
                                        {promoCode.status === 'inactive' && (
                                            <Chip
                                                label={promoCode.status?.charAt(0).toUpperCase() + promoCode.status?.slice(1)}
                                                size="medium"
                                                chipcolor="orange"
                                            />
                                        )}
                                    </TableCell>
                                    <TableCell align="center" sx={{ pr: 3 }}>
                                        <ActionMenu promoCode={promoCode} handleRefetch={handleRefetch} />
                                    </TableCell>
                                </TableRow>
                            ))}
                        </>
                    )}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default BrandedAppPromoCodeTable;
